<div fxLayout="row" fxLayoutAlign="space-between center">
    <mat-icon [style.color]="iconColor">{{data?.icon}}</mat-icon> <span>{{data?.message}}</span> <button style="border-radius: 50%; width: 30px; height: 30px;" (click)="dismiss()">x</button>
</div>
